<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M17.6 2c-1.833 0-3.408 1.142-4.067 2.75A6.89 6.89 0 0 0 8.95 3.008C5.117 3.008 2 6.125 2 9.95c0 6.433 6.15 11.633 6.417 11.85a.837.837 0 0 0 1.066 0c.234-.192 5.05-4.275 6.175-9.658.725.858 1.35 1.383 1.409 1.441a.837.837 0 0 0 1.066 0C18.292 13.45 22 10.317 22 6.408 22 3.983 20.025 2 17.6 2ZM8.95 13.733A3.791 3.791 0 0 1 5.167 9.95c0-2.083 1.7-3.783 3.783-3.783s3.783 1.7 3.783 3.783-1.7 3.783-3.783 3.783Zm8.65-4.775a2.54 2.54 0 0 1-1.992-.983 6.99 6.99 0 0 0-.525-1.292c-.008-.091-.025-.183-.025-.283a2.55 2.55 0 1 1 2.55 2.55l-.008.008Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
